var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.renderMenu)?_c('Top'):_vm._e(),_c('Intro',{on:{"animation-ends":function($event){_vm.renderMenu = true}}}),_c('OurServices'),_c('Steps'),_c('AboutMe'),_c('Order'),_c('RFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }